import { PolarisBreakPoint } from '@/constants/enum';
import styled from 'styled-components';

export const StyledTemplateButtons = styled.div`
  .btn-group {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: center;

    /* Mobile responsive */
    @media (max-width: ${PolarisBreakPoint.MD}) {
      flex-direction: column;
      align-items: stretch;
      gap: 0.75rem;

      button {
        width: 100%;
      }
    }
  }
`;

export const StyledVariableList = styled.div`
  margin-top: 1rem;

  .variable-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;

    .variable-badge {
      width: 12.5rem;
    }
  }
`;
